import Nullstack from 'nullstack';
export default function IconKarate({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-karate",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M3 9l4.5 1l3 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M13 21v-8l3 -5.5"
  }), "   ", Nullstack.element("path", {
    d: "M8 4.5l4 2l4 1l4 3.5l-2 3.5"
  }), " ");
}